import { getPluralized } from '@shared/helpers';

interface PositionLabels {
    one: string;
    few: string;
    many: string;
}

export const getEquipmentPositionText = (count: number, labels: PositionLabels) =>
    getPluralized(count, labels);
